module.exports = __webpack_public_path__ + "static/media/cookedcavebanana.e5ddeba0.webp";